<template>
  <div>
    <el-alert
      :title="deleteMessage"
      type="warning"
      :closable="false"
      center
      show-icon
    >
    </el-alert>
  </div>
</template>

<script>
import moment from 'moment'
import i18n from '@/core/utils/I18n'

export default {
  name: 'ProjectInactiveBanner',

  data() {
    return {
      deletionDate: moment
        .unix(this.$store.getters.deleteTime)
        .format(this.dateFormat())
    }
  },

  methods: {
    dateFormat() {
      // set locale to en-GB to display the default date in dd/mm/yyyy format
      const locale = i18n.locale === 'en' ? 'en-GB' : i18n.locale
      return moment.localeData(locale).longDateFormat('L')
    }
  },

  computed: {
    deleteMessage() {
      return this.$t('Project_Inactive_Message', { date: this.deletionDate })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/ProjectInactiveBanner.vue